var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnVisibilityOff = function SvgBtnVisibilityOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.74 5.138A12.524 12.524 0 0 0 12 3.75 12.575 12.575 0 0 0 .302 11.725a.75.75 0 0 0 0 .55 12.602 12.602 0 0 0 4.556 5.746l1.08-1.08A11.11 11.11 0 0 1 1.81 12l.123-.277A11.073 11.073 0 0 1 12 5.25l.305.004.303.013c1.415.077 2.771.423 4.01.993l1.122-1.122Zm2.526 1.717-1.063 1.064A11.106 11.106 0 0 1 22.189 12l-.122.277A11.073 11.073 0 0 1 12 18.75l-.305-.004-.303-.013a11.03 11.03 0 0 1-2.559-.445l-1.185 1.185a12.576 12.576 0 0 0 16.05-7.198.75.75 0 0 0 0-.55 12.6 12.6 0 0 0-3.432-4.87Zm-9.68 9.68a4.751 4.751 0 0 0 5.95-5.95l-1.288 1.289.002.126a3.251 3.251 0 0 1-3.376 3.248l-1.288 1.288Zm.422-4.665.862-.862a1 1 0 0 0-.862.862Zm2.66-2.66a3.251 3.251 0 0 0-4.457 4.457l-1.083 1.084a4.751 4.751 0 0 1 6.623-6.623L13.668 9.21Z",
    fill: "#A4A7AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21 21 3",
    stroke: "#A4A7AD",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
};
export default SvgBtnVisibilityOff;